<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <iframe src="/crono/animacao.html?lang=pt" frameborder="0" width="100%" height="650" style="overflow: hidden;"></iframe>
  </div>
</ng-template>

<section class="subhero">
  <div class="container">
    <div class="row">
      <h2>Animações</h2>
    </div>
  </div>
</section>
<div class="container content">
  <div class="row">
    <div class="col">
      <h3>Assista a animação Tempo na Vida</h3>
      <p class="clear spacer-30-both">Acompanhe os ritmos biológicos de cada familiar ao longo do dia. Para ver gráficos e comparativos dos ritmos cardíacos, temperaturas, eletros, basta clicar sobre os personagens.</p>
      <button class="btn btn-lg btn-outline-primary" (click)="open(content)">Abrir animação!</button>
    </div>
  </div>
</div>
